import { proxy } from 'valtio';
export const useSyntheticIndexStore = proxy({
    /** 合成期貨 = 價平履約價 + 價平買權現價 - 價平賣權現價 */
    syntheticIndexPrice: 0,
    /** 價平時間價值 = 價平前後兩檔時間價值加總除以4 */
    atThePriceAvgTimeValue: 0,
});
